import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicyDetails = () => {
  return (
    <>
      <section className='support-content ptb-120'>
        <div className='container'>
          <div className='row justify-content-between'>
            <div className='col-lg-12 col-md-8 p-lg-5'>
              <div className='support-article-wrap text-center'>
                <h1 className='display-5 mb-4 fw-bold'>
                  Cookie Policy
                </h1>

                <div className='job-details-info my-5'>
                  <h3 className='h5'>
                    Version 01, August 2024
                  </h3>
                  <ul className='list-unstyled'>
                    <li>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='support-article-wrap'>
                    <p>
                      This document contains our Cookie policy for Sunlex official website, accessible https://www.sunlex.net (‘our website’).
                    </p>
                    <p>
                      This document describes what information is gathered via cookies, how we use it and why we sometimes need to store these cookies.
                      This document also informs how you can prevent these cookies from being stored, however this may downgrade or 'break' certain elements of our website's functionality.
                    </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        What is a cookie?
                      </h4>
                      <p>
                        Cookies are small pieces of information, normally consisting of just letters and numbers, which are downloaded to your device (typically a computer or mobile device, but also other equipment such as wearable technology or smart TV) when you visit www.sunlex.net.
                      </p>
                      <p>
                        Software on your device (for example a web browser) can store cookies and send them back to our website next time you visit.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        What are cookies used for?
                      </h4>
                      <p>
                        Cookies are used in numerous ways, such as supporting you to log in to our website, analysing traffic to our website or tracking your browsing behaviour. Description of the purpose for which a cookie is used is provided in the tables below.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        What types of cookies do we use?
                      </h4>
                      <p>
                        The cookies used or that will be used from time to time on our website have been categorised based on
                        the categories found in Guidance on the use of cookies and similar technologies, issued by UK Information
                        Commissioner's Office.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Necessary cookies. Visitor preferences
                      </h4>
                      <p>
                        We use necessary cookies to make our website work. Necessary cookies enable core functionality of the
                        Website such as its accessibility.
                      </p>
                      <p>
                        <table>
                            <tr>
                              <th>cookie</th>
                              <th>name</th>
                              <th>type</th>
                              <th>purpose</th>
                              <th>duration</th>
                            </tr>
                            <tr>
                              <td>general purpose identifier</td>
                              <td>PHPSESSID</td>
                              <td>session, 1st party</td>
                              <td>used to maintain user session variables</td>
                              <td>end of the browser session</td>
                            </tr>
                            <tr>
                              <td>Cookie consent</td>
                              <td>Cookie Control</td>
                              <td>persistent, 1st party</td>
                              <td>used to store the data about the user's cookies preferences for the current website</td>
                              <td>90 days</td>
                            </tr>
                          </table>
                      </p>
                      <p>
                        ‘Session cookies’ are cookies that expire at the end of a browser session (normally when a user
                        exits their browser). Session cookies allow the website to recognise and link your actions during
                        a browsing session. Because session cookies are temporal, they do not accumulate information for your identity or from your device.
                      </p>
                      <p>
                        ‘Persistent cookies’ are cookies that are stored on your device in-between sessions. They allow
                        your preferences and choices when using our website (such as language preferences) to be remembered.
                        These cookies are temporal and set to expire at a certain point in the future (as per their duration period).
                      </p>
                </div>

                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Analytics cookies
                      </h4>
                      <p>
                        The analytics cookies assess your interaction with our website as an anonymous user. They collect
                        information in a way that does not directly identify anyone. The analytics cookies are persistence cookies.
                      </p>
                      <p>
                        We intend to set Google Analytics cookies to help us to improve our website by collecting and
                        reporting information on how you use it. The browsing experience of our website visitors is NOT tracked by Google Analytics by default.
                      </p>
                      <p>
                        You may, though, choose to consent to contributing your browsing experience on our website for
                        us to produce anonymised statistics by accepting the analytics cookies or you can refuse – either
                        through selecting your preference in our website or the site's cookie banner when you first visit it.
                      </p>
                      <p>
                        You can always decide to withdraw your consent or consent again at any time.
                      </p>
                      <p>
                        You will be able to access our website, whether analytics cookies are accepted or not.
                      </p>
                      <p>
                        If you intend to accept the analytics cookies` performance on your web browser, please consider the
                        Google Ads related information in section “Targeting and advertising cookies” further in this policy.
                      </p>
                      <p>
                        We intend to use the analytics cookies described below. However, we will not set analytics cookies
                        unless you explicitly accept them.
                      </p>
                      <p>

                        <table>
                          <tr>
                            <th>cookie</th>
                            <th>name</th>
                            <th>type</th>
                            <th>purpose</th>
                            <th>duration</th>
                          </tr>
                          <tr>
                            <td rowspan="4">Google Analytics 4</td>
                          </tr>
                          <tr>
                            <td>_ga_22P44MQ4FL</td>
                            <td>persistent, 3rd party</td>
                            <td>used for throttling analytics requests to limit requests being sent from your browser to Google services</td>
                            <td>1 minute</td>
                          </tr>
                          <tr>
                            <td>_gid</td>
                            <td>persistent, 3rd party</td>
                            <td>used to store your unique Client ID to Google Analytics</td>
                            <td>24 hours</td>
                          </tr>
                          <tr>
                            <td>_ga</td>
                            <td>persistent, 3rd party</td>
                            <td>used to uniquely identify users. Each action that the user makes on the website is called a Hit, and sends data along with your unique Client ID to Google Analytics</td>
                            <td>2 years</td>
                          </tr>
                        </table>

                      </p>

                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        Removing cookies
                      </h4>
                      <p>
                        You may delete previously set cookies manually or configure the browser settings to delete cookies at a set interval.
                      </p>
                      <p>
                        You can delete all cookies that are already on your device by clearing the browsing history of your browser. Please, see your browser ‘Help’ for how to do this. This will remove all cookies from all websites you have visited.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        More information
                      </h4>
                      <p>
                        We are committed to respecting your privacy.
                      </p>
                      <p>
                        We do not collect any other information about you as a visitor to our website, except that gathered by the cookies listed above. These cookies are not used for any purpose other the described in this policy.
                      </p>
                      <p>
                        Hopefully this policy provides you clearly inform about what types of cookies do we use and what they do. However, if you are still looking for more information, then you can contact us at dpo@sunlex.net.
                      </p>
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CookiePolicyDetails;
